import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
/**
 * Custom methods
 * -----------------------------------------------------------------------------
 *
 * @namespace custom
 */

// media queries in Javascript => http://wicky.nillia.ms/enquire.js/
import enquire from 'enquire.js';
// detect if a device is mouseOnly, touchOnly, or hybrid => http://detect-it.rafrex.com/
import detectIt from 'detect-it';
import axios from 'axios';
import Flickity from 'flickity';
import 'flickity-as-nav-for';
import 'flickity-fullscreen';
import { find } from 'filepond';

var autocomplete = void 0;
var componentForm = {
  street_number: 'short_name',
  route: 'long_name',
  locality: 'long_name',
  postal_code: 'short_name'
};

var customMethods = {
  mounted: function mounted() {},
  data: function data() {
    return {
      // installation videos
      selectedModelVideo: '',
      selectedTypeVideo: '',
      orderLastZipResponse: [],
      orderSerialOrderResponse: ''
    };
  },


  methods: {
    _initCustomMethods: function _initCustomMethods() {

      app._checkScript();
      app._customTriggers();

      var $siteHeader = $(app.selectors.siteHeader);
      var $mainNav = $siteHeader.find('nav');
      var $topBar = $siteHeader.find('[data-top-bar]');
      var $bottomBar = $siteHeader.find('[data-bottom-bar]');
      var navHeight = void 0;
      var navHeight2 = void 0;

      if ($topBar.length > 0) {
        navHeight = $mainNav.outerHeight() + $topBar.outerHeight() + $bottomBar.outerHeight();
        navHeight2 = $mainNav.outerHeight() + $topBar.outerHeight();
      } else {
        navHeight = $mainNav.outerHeight();
        navHeight2 = $mainNav.outerHeight();
      }

      if ($siteHeader.data('fixed-header')) {
        // boolean
        $('body #app').css('padding-top', navHeight);
      } else {
        $headerSlider.css('height', $headerSlider.outerHeight() - navHeight);
      }

      if ($('[data-section-id="order_swatches"]').length > 0) {
        setTimeout(function () {
          app._autoComepleteByGoogle();
          new Shopify.CountryProvinceSelector('p_country', 'p_state', {
            hideElement: 'p_state_container'
          });
        }, 700);
      }

      $('[data-search-layer] .search-reveal, .mobile-nav-drawer').css('top', navHeight2);
      $('[data-menu]').click(function () {
        $('[data-menu]').toggleClass('d-none');
        $('[data-close]').toggleClass('d-none');
      });
      $('[data-close]').click(function () {
        $('[data-menu]').toggleClass('d-none');
        $('[data-close]').toggleClass('d-none');
      });

      if ($('[data-installation-video]').length > 0) {
        app._allVideos();
      }

      $('body').on('click', '.flickity-fullscreen-button', function () {
        $('[data-site-header]').removeClass('fixed-top');
      });

      $('body').on('click', '.flickity-fullscreen-button-exit, [data-dismiss="modal"]', function () {
        $('[data-site-header]').addClass('fixed-top');
      });

      $('body').on('click', '[data-new-modal]', function () {
        $('#differentVehicleModal').modal('hide');
        $('#changeVehicleModal').modal('show');
        $('#changeVehicleModal [data-dismiss="modal"]').hide();
      });

      $('body').on('click', '.product_infoTabs a', function (event) {
        $('.product_infoTabs a').removeClass('active');
        $(event.currentTarget).addClass('active');
        var target = $(event.currentTarget).attr('href');

        setTimeout(function () {
          $(target).click();
          $('#collapse-' + target.split('#')[1]).addClass('highlight');
        }, 800);
      });

      $('#form_input_shopping').change(function () {
        var target = $(this).children('option:selected').val();
        // eslint-disable-next-line eqeqeq
        if (target != '') {
          $('.option-form').removeClass('show');
          $('#' + target).addClass('show');
        } else {
          $('.option-form').removeClass('show');
        }
      });

      // eslint-disable-next-line eqeqeq
      if (app.currentTemplate == 'product' && $('.section-related-products .flickity-slider').html().length == 0) {
        $('.section-related-products').hide();
      }

      $('#videoModal .close').click(function () {
        $('#videoModal iframe').attr('src', $(this).closest('#videoModal').find('iframe').attr('src'));
      });

      $('#serial-number-link').on('click', function (event) {
        event.preventDefault();
        $('.already-ordered').removeClass('show');
        $('#serial-number-form').toggleClass('show');
      });
      $('#lastname-form-link').on('click', function (event) {
        event.preventDefault();
        $('.already-ordered').removeClass('show');
        $('#lastname-form').toggleClass('show');
      });
      $('#serial-dealer-link').on('click', function (event) {
        event.preventDefault();
        $('.track-order').removeClass('show');
        $('#trackorder-distributors').toggleClass('show');
      });
      $('#trackorder-lastname-link').on('click', function (event) {
        event.preventDefault();
        $('.track-order').removeClass('show');
        $('#trackorder-lastname').toggleClass('show');
      });

      $('body').on('change', '[data-check-input] input', function (event) {
        var value = $(event.currentTarget).closest('[data-seat-template]').find('select').val();
        // eslint-disable-next-line eqeqeq
        if (value != null) {
          var dataType = $('[data-seat-template]')[0];
          if ($(dataType).find('[data-check-input] [data-color-swatch-group] .color-swatch').length == 1 && $(dataType).find('[data-check-select] [data-more-about] option').length == 2) {
            $('[data-add-to-cart-seat]').removeAttr('disabled').html(' Add to Cart <span data-price-change class="ml-1"></span>');
            $('[data-add-to-cart-seat] [data-price-change]').text('- ' + $('[data-var-price]:first').text());
          } else {
            $('[data-add-to-cart-seat]').removeAttr('disabled');
          }
        } else {
          $('[data-add-to-cart-seat]').attr('disabled', 'disabled');
        }
      });

      $('body').on('change', '[data-check-select] select', function (event) {
        var value = $(event.currentTarget).closest('[data-seat-template]').find('input:checked').val();
        // eslint-disable-next-line eqeqeq
        if (value != undefined) {
          var dataType = $('[data-seat-template]')[0];
          if ($(dataType).find('[data-check-input] [data-color-swatch-group] .color-swatch').length == 1 && $(dataType).find('[data-check-select] [data-more-about] option').length == 2) {
            $('[data-add-to-cart-seat]').removeAttr('disabled').html(' Add to Cart <span data-price-change class="ml-1"></span>');
            $('[data-add-to-cart-seat] [data-price-change]').text('- ' + $('[data-var-price]:first').text());
          } else {
            $('[data-add-to-cart-seat]').removeAttr('disabled');
          }
        } else {
          $('[data-add-to-cart-seat]').attr('disabled', 'disabled');
        }
      });

      var min = 50;
      var max = 650;

      // eslint-disable-next-line func-style
      var calcLeftPosition = function calcLeftPosition(value) {
        return 100 / (650 - 50) * (value - 50);
      };

      if ($('#rangeMin').length > 0) {
        $('#rangeMin').on('input', function (e) {
          // eslint-disable-next-line radix
          var newValue = parseInt(e.target.value);
          if (newValue > max) {
            return;
          }
          min = newValue;
          $('#thumbMin').css('left', calcLeftPosition(newValue) + '%');
          $('#min').html('$' + newValue);
          $('[data-min-price]').attr('data-min-price', newValue);
          $('#line').css({
            left: calcLeftPosition(newValue) + '%',
            right: 100 - calcLeftPosition(max) + '%'
          });
          app._getDataProducts();
        });
      }
      if ($('#rangeMax').length > 0) {
        $('#rangeMax').on('input', function (e) {
          // eslint-disable-next-line radix
          var newValue = parseInt(e.target.value);
          if (newValue < min) {
            return;
          }
          max = newValue;
          $('#thumbMax').css('left', calcLeftPosition(newValue) + '%');
          $('[data-max-price]').attr('data-max-price', newValue);
          $('#max').html('$' + newValue);
          $('#line').css({
            left: calcLeftPosition(min) + '%',
            right: 100 - calcLeftPosition(newValue) + '%'
          });
          app._getDataProducts();
        });
      }

      $('body').on('click toucjstart', '[data-checkout-check]', function (e) {
        e.preventDefault();
        var flag = false;
        app.cart.items.forEach(function (item) {
          // eslint-disable-next-line eqeqeq
          if (item.vendor == 'CoverkingUSA') {
            // eslint-disable-next-line eqeqeq
            if (item.properties.ItemID == undefined && item.properties.Recid == undefined && item.properties.Recid == undefined) {
              flag = true;
            }
          }
        });
        if (flag) {
          app._snotifyMsg('Error', 'Information is missing. Please remove the existing product and add it again.', 'Error');
        } else {
          window.location.href = '/checkout';
        }
      });
    },
    _isInViewport: function _isInViewport(x) {
      var elementTop = $(x).offset().top;
      var elementBottom = elementTop + $(x).outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      return elementBottom > viewportTop && elementTop < viewportBottom;
    },
    _customTriggers: function _customTriggers() {
      $(window).on('resize scroll', function () {
        if (document.querySelectorAll('[data-footer-top]').length > 0) {
          if (app._isInViewport('[data-footer-top]')) {
            app._klaviyoScript();
          }
        }
        if (document.querySelectorAll('#insta-feed').length > 0) {
          if (app._isInViewport('#insta-feed')) {
            app._instaScript();
          }
        }
        if (document.querySelectorAll('.broadlyReviewsWrapper').length > 0) {
          if (app._isInViewport('.broadlyReviewsWrapper')) {
            app._reviewScript();
          }
        }
      });
    },
    _instaScript: function _instaScript() {
      if (app.allScript.indexOf('instafeed.nfcube.com') === -1) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.defer = true;
        script.async = true;
        script.src = 'https:\/\/instafeed.nfcube.com\/cdn\/f6e66cda9a06c2ccea8c73a48ae4cb5b.js';
        document.getElementsByTagName('head')[0].appendChild(script);
        app._checkScript();
      }
    },
    _reviewScript: function _reviewScript() {
      console.log(app.allScript);
      if (app.allScript.indexOf('embed.broadly.com/include.js') === -1) {
        var script1 = document.createElement('script');
        script1.type = 'text/javascript';
        script1.src = 'https://embed.broadly.com/include.js';
        document.querySelector('.broadlyReviewsWrapper').appendChild(script1);
        document.querySelector('.broadlyReviewsWrapper script').setAttribute('data-url', '/58b9c630d05168006b194de7/reviews?recent=3');
        app._checkScript();
      }
    },
    _klaviyoScript: function _klaviyoScript() {
      if (app.allScript.indexOf('klaviyo_subscribe.js') === -1) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.defer = true;
        script.async = true;
        script.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=VHKvh6';
        document.getElementsByTagName('head')[0].appendChild(script);

        script = document.createElement('script');
        script.type = 'text/javascript';
        script.defer = true;
        script.async = true;
        script.src = 'https://www.klaviyo.com/media/js/public/klaviyo_subscribe.js';
        document.getElementsByTagName('head')[0].appendChild(script);
        setTimeout(function () {
          KlaviyoSubscribe.attachToForms('#email-signup-desktop', {
            hide_form_on_success: true
          });
          KlaviyoSubscribe.attachToForms('#email-signup-mobile', {
            hide_form_on_success: true
          });
        }, 500);
        app._checkScript();
      }
    },
    _getVariantByProduct: function _getVariantByProduct(event) {
      var handle = app._handleize($(event.currentTarget).val());
      app.currentVariantUniversalTitle = '';
      app.currentVariantUniversalID = '';
      app.shipDays = '';
      app.itemID = '';
      $('[data-price-change]').text('');
      $('[data-single-option-selector]').prop('checked', false);
      $('[data-closest]').addClass('d-none');
      $('[data-closest="' + handle + '"]').removeClass('d-none');
    },
    _getUniversalVariant: function _getUniversalVariant(event, id, title, price, sku) {
      app.currentVariantUniversalTitle = title;
      app.currentVariantUniversalID = id;
      app.itemID = sku;
      $('[data-price-change]').text('' + app._formatMoney(price));
      axios.get('https://cpiapi.coverking.com/api/get-vehicle-details?type=ship-days&itemId=' + app.itemID)
      // eslint-disable-next-line promise/always-return
      .then(function (response) {
        app.shipDays = response.data.Ship_Days.Business_Days;
      }).catch(function (error) {
        throw error;
      });
    },
    _getDataProducts: function _getDataProducts() {
      var productsData = [];
      app.allProducts.forEach(function (item) {
        var priceMin = $('[data-min-price]').attr('data-min-price');
        var priceMax = $('[data-max-price]').attr('data-max-price');
        var dataValue = app._formatMoney(item.price_min).split('$')[1];
        // eslint-disable-next-line radix
        if (parseFloat(dataValue) >= parseInt(priceMin) && parseFloat(dataValue) <= parseInt(priceMax)) {
          var product = item;

          // add default current_variant object
          product.current_variant = product.variants[0];

          // add product options
          product.options_with_values = item.options_with_values;

          // description
          // eslint-disable-next-line promise/no-nesting
          axios.get('/products/' + product.handle + '?view=metafields.json').then(function (response) {
            // eslint-disable-next-line eqeqeq
            if (response.data.list_description != undefined && response.data.list_title != undefined) {
              // description
              product.product_details = app._stripHtml(response.data.list_description).substring(0, 70) + '...';
              product.title = response.data.list_title;
            } else {
              // description
              product.product_details = app._stripHtml(product.description).substring(0, 70) + '...';
            }
            return response;
          }).catch(function (error) {
            throw error;
          });

          // add cart limit tag
          product.tags.forEach(function (tag) {
            if (tag.match('cart-limit')) {
              var cartLimit = tag.replace('cart-limit-', '');
              product.cart_limit = parseFloat(cartLimit);
            }
          });

          // exclude products that have the app.productExcludeTag (theme settings)
          if (product.tags.indexOf(app.productExcludeTag) === -1) {
            productsData.push(product);
          }
        }
      });
      app.collection.products = productsData;
    },
    _formShow: function _formShow(event, name) {
      // eslint-disable-next-line eqeqeq
      if (name == 'contact') {
        $('[data-form-contact]').removeClass('d-none');
        $('[data-form-war]').addClass('d-none');
        $('.hw-action').removeClass('active');
      } else {
        $('[data-form-war]').removeClass('d-none');
        $('[data-form-contact]').addClass('d-none');
        $(event.currentTarget).addClass('active');
      }
    },
    _openYMMModal: function _openYMMModal(event) {
      app.isLoading = true;
      $(event.currentTarget).hide();
      $('[data-hide-section]').removeClass('d-none');
      $('[data-notify-me], [data-vehicle-section]').addClass('d-none');
      app.isLoading = false;
    },
    _topFunction: function _topFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    _getUniversalSeatCover: function _getUniversalSeatCover() {
      axios.get('https://cpiapi.coverking.com/api/get-vehicle-details?type=universal-seat-cover').then(function (response) {
        app.getUniversalDesign = response.data.Designs;
        return response.data;
      }).catch(function (error) {
        throw error;
      });
    },
    _getUniversalSeatCategory: function _getUniversalSeatCategory() {
      axios.get('https://cpiapi.coverking.com/api/get-vehicle-details?type=seat-cover-categories&designName=' + app.selectedUniversalDesign).then(function (response) {
        app.getUniversalCategory = response.data.Categories;
        return response.data;
      }).catch(function (error) {
        throw error;
      });
    },
    _getUniversalSeatResources: function _getUniversalSeatResources() {
      axios.get('https://cpiapi.coverking.com/api/get-vehicle-details?type=cover-category-resources&designName=' + app.selectedUniversalDesign + '&categoryName=' + app.selectedUniversalCategory).then(function (response) {
        app.getUniversalResourse = response.data.Resources;
        return response.data;
      }).catch(function (error) {
        throw error;
      });
    },
    _getVals: function _getVals() {
      // Get slider values
      var parent = this.parentNode;
      var slides = parent.getElementsByTagName('input');
      var slide1 = parseFloat(slides[0].value);
      var slide2 = parseFloat(slides[1].value);
      // Neither slider will clip the other, so make sure we determine which is larger
      // eslint-disable-next-line max-statements-per-line
      if (slide1 > slide2) {
        var tmp = slide2;slide2 = slide1;slide1 = tmp;
      }

      var displayElementmin = parent.getElementById('rangeValuesmin')[0];
      var displayElementmax = parent.getElementById('rangeValuesmax')[0];
      displayElementmin.innerHTML = '$' + slide1;
      displayElementmax.innerHTML = '$' + slide2;
    },
    _getYear: function _getYear() {
      // eslint-disable-next-line eqeqeq
      if (app.currentTemplate == 'product') {
        // eslint-disable-next-line eqeqeq
        // if (app._getCookie('productID') != 'productID') {
        axios.get('https://cpiapi.coverking.com/api/get-vehicle-details?type=years&productId=' + app._getCookie('productID')).then(function (response) {
          app.getYearJson = response.data.Years;
          return response.data;
        }).catch(function (error) {
          throw error;
        });
        // }
      } else {
        axios.get('https://cpiapi.coverking.com/api/get-vehicle-details?type=years').then(function (response) {
          app.getYearJson = response.data.Years;
          return response.data;
        }).catch(function (error) {
          throw error;
        });
      }
    },
    _yearChange: function _yearChange(event) {
      app.selectedYear = $(event.currentTarget).val();
      $('[data-target-model]').attr('disabled', 'disabled').val('model');
      $('[data-target-submodel]').attr('disabled', 'disabled').val('submodel');
      app._getMake();
      app.selectedMake = '';
      app.selectedModel = '';
      app.selectedSubModel = '';
    },
    _getMake: function _getMake() {
      // eslint-disable-next-line eqeqeq
      if (app.currentTemplate == 'product') {
        axios.get('https://cpiapi.coverking.com/api/get-vehicle-details?type=makes&productId=' + app._getCookie('productID') + '&year=' + app.selectedYear).then(function (response) {
          app.getMakeJson = response.data.Makes;
          $('[data-target-make]').removeAttr('disabled').val('make');
          return response.data;
        }).catch(function (error) {
          throw error;
        });
      } else {
        axios.get('https://cpiapi.coverking.com/api/get-vehicle-details?type=makes&year=' + app.selectedYear).then(function (response) {
          app.getMakeJson = response.data.Makes;
          $('[data-target-make]').removeAttr('disabled').val('make');
          return response.data;
        }).catch(function (error) {
          throw error;
        });
      }
    },
    _makeChange: function _makeChange(event) {
      app.selectedMake = $(event.currentTarget).val();
      $('[data-target-model]').attr('disabled', 'disabled').val('model');
      $('[data-target-submodel]').attr('disabled', 'disabled').val('submodel');
      app._getModel();
      app.selectedModel = '';
      app.selectedSubModel = '';
    },
    _getModel: function _getModel() {
      // eslint-disable-next-line eqeqeq
      if (app.currentTemplate == 'product') {
        axios.get('https://cpiapi.coverking.com/api/get-vehicle-details?type=models&productId=' + app._getCookie('productID') + '&year=' + app.selectedYear + '&make=' + app.selectedMake).then(function (response) {
          app.getModelJson = response.data.Models;
          $('[data-target-model]').removeAttr('disabled').val('model');
          return response.data;
        }).catch(function (error) {
          throw error;
        });
      } else {
        axios.get('https://cpiapi.coverking.com/api/get-vehicle-details?type=models&year=' + app.selectedYear + '&make=' + app.selectedMake).then(function (response) {
          app.getModelJson = response.data.Models;
          $('[data-target-model]').removeAttr('disabled').val('model');
          return response.data;
        }).catch(function (error) {
          throw error;
        });
      }
    },
    _modelChange: function _modelChange(event) {
      app.selectedModel = $(event.currentTarget).val();
      $('[data-target-submodel]').attr('disabled', 'disabled').val('submodel');
      app._getSubModel();
      app.selectedSubModel = '';
    },
    _getSubModel: function _getSubModel(type) {
      // eslint-disable-next-line eqeqeq
      if (app.currentTemplate == 'product') {
        axios.get('https://cpiapi.coverking.com/api/get-vehicle-details?type=sub-models&productId=' + app._getCookie('productID') + '&year=' + app.selectedYear + '&make=' + app.selectedMake + '&model=' + app.selectedModel).then(function (response) {
          app.getSubModelJson = response.data.Sub_Models;
          app.selectedbaseVehicle = response.data.Base_Vehicle;
          // eslint-disable-next-line eqeqeq
          if (type == 'redirect') {
            // Cookies
            var today = new Date();
            var expirationDate = new Date();
            expirationDate.setDate(today.getDate());
            var time = expirationDate.getTime();
            var expireTime = time + 1000 * 36000;
            expirationDate.setTime(expireTime);
            document.cookie = 'vehicle_base_vehicle=' + app.selectedbaseVehicle + ';expires=' + expirationDate.toGMTString() + ';path=/';
          } else {
            $('[data-target-submodel]').removeAttr('disabled').val('submodel');
          }
          return response.data;
        }).catch(function (error) {
          throw error;
        });
      } else {
        axios.get('https://cpiapi.coverking.com/api/get-vehicle-details?type=sub-models&year=' + app.selectedYear + '&make=' + app.selectedMake + '&model=' + app.selectedModel).then(function (response) {
          app.getSubModelJson = response.data.Sub_Models;
          app.selectedbaseVehicle = response.data.Base_Vehicle;
          $('[data-target-submodel]').removeAttr('disabled').val('submodel');
          return response.data;
        }).catch(function (error) {
          throw error;
        });
      }
    },
    _submodelChange: function _submodelChange(event) {
      app.selectedSubModel = $(event.currentTarget).val();
    },
    _submodelChangeProduct: function _submodelChangeProduct(event) {
      app.isLoading = true;
      app.selectedSubModel = $(event.currentTarget).val();
      app._setVehicleCookie();
      app._switchProductsURL();
    },
    _getOption: function _getOption(onlymat, nomat) {
      app.isLoading = true;
      axios.get('https://cpiapi.coverking.com/api/get-vehicle-details?type=options&onlymat=' + onlymat + '&nomat=' + nomat + '&productId=' + app._getCookie('productID') + '&mcat=' + app._getCookie('mcat') + '&subModel=' + app._getCookie('vehicle_submodel') + '&baseVehicle=' + app._getCookie('vehicle_base_vehicle') + '&make=' + app._getCookie('vehicle_make') + '&model=' + app._getCookie('vehicle_model') + '&year=' + app._getCookie('vehicle_year')).then(function (response) {
        app.getOptionJson = response.data;
        if (app.getOptionJson.Video) {
          setTimeout(function () {
            $('[data-video-check]').removeClass('d-none');
            $('[data-video-check]').find('iframe').attr('src', app.getOptionJson.Video.Link.replace('watch?v=', 'embed/')).attr('title', app.getOptionJson.Video.Title);
          }, 300);
        }

        if (app.getOptionJson.Option_Generated.length == 0) {
          $('[data-hide-notify-me]').addClass('d-none').removeClass('d-flex');
          $('[data-notify-me-2]').removeClass('d-none');
        } else {
          $('[data-hide-notify-me]').removeClass('d-none').addClass('d-flex');
          $('[data-notify-me-2]').addClass('d-none');
        }

        app.isLoading = false;
        return response.data;
      }).catch(function (error) {
        app.isLoading = false;
        throw error;
      });
    },
    _showWizard: function _showWizard() {
      app._setVehicleCookie();
      window.location.href = '/pages/recommendation-wizard';
    },
    _redirectOnPDP: function _redirectOnPDP() {
      app.isLoading = true;
      app._setVehicleCookie();
      // eslint-disable-next-line max-statements-per-line
      var customHandle = void 0;var makeHandle = void 0;
      // eslint-disable-next-line eqeqeq
      if (app._getCookie('productID') == 'DFM' || app._getCookie('productID') == 'CCL') {
        customHandle = app._handleize(app._getCookie('vehicle_year')) + '-' + app._handleize(app._getCookie('vehicle_make')) + '-' + app._handleize(app._getCookie('vehicle_model'));
        makeHandle = customHandle + '-floor-mats';
        // eslint-disable-next-line eqeqeq
      } else if (app._getCookie('productID') == 'CVC') {
        customHandle = app._handleize(app._getCookie('vehicle_year')) + '-' + app._handleize(app._getCookie('vehicle_make')) + '-' + app._handleize(app._getCookie('vehicle_model'));
        makeHandle = customHandle + '-car-cover';
        // eslint-disable-next-line eqeqeq
      } else if (app._getCookie('productID') == 'CSC' || app._getCookie('productID') == 'MSC' || app._getCookie('productID') == 'CTSC') {
        customHandle = app._handleize(app._getCookie('vehicle_year')) + '-' + app._handleize(app._getCookie('vehicle_make')) + '-' + app._handleize(app._getCookie('vehicle_model'));
        makeHandle = customHandle + '-seat-cover';
        // eslint-disable-next-line eqeqeq
      } else if (app._getCookie('productID') == 'CDC' || app._getCookie('productID') == 'MDC') {
        customHandle = app._handleize(app._getCookie('vehicle_year')) + '-' + app._handleize(app._getCookie('vehicle_make')) + '-' + app._handleize(app._getCookie('vehicle_model'));
        makeHandle = customHandle + '-dash-cover';
        // eslint-disable-next-line eqeqeq
      } else if (app._getCookie('productID') == 'CRD') {
        customHandle = app._handleize(app._getCookie('vehicle_year')) + '-' + app._handleize(app._getCookie('vehicle_make')) + '-' + app._handleize(app._getCookie('vehicle_model'));
        makeHandle = customHandle + '-rear-deck-cover';
        // eslint-disable-next-line eqeqeq
      } else if (app._getCookie('productID') == 'CFS') {
        customHandle = app._handleize(app._getCookie('vehicle_year')) + '-' + app._handleize(app._getCookie('vehicle_make')) + '-' + app._handleize(app._getCookie('vehicle_model'));
        makeHandle = customHandle + '-frost-shield';
        // eslint-disable-next-line eqeqeq
      } else if (app._getCookie('productID') == 'CSS') {
        customHandle = app._handleize(app._getCookie('vehicle_year')) + '-' + app._handleize(app._getCookie('vehicle_make')) + '-' + app._handleize(app._getCookie('vehicle_model'));
        makeHandle = customHandle + '-custom-sunshield';
      }
      axios.get('/products/' + makeHandle)
      // eslint-disable-next-line promise/always-return
      .then(function (response) {
        app.cookieSelectedVehicleURL = '/products/' + makeHandle;
        setTimeout(function () {
          window.location.href = app.cookieSelectedVehicleURL;
        }, 300);
      }).catch(function (error) {
        window.location.href = '/pages/recommendation-wizard';
        throw error;
      });
    },


    // _getOptionProduct(onlymat, nomat) {
    //   // eslint-disable-next-line eqeqeq
    //   if (app.currentTemplate == 'product') {
    //     app.isLoading = true;
    //     app._setVehicleCookie();
    //     axios.get(`https://cpiapi.coverking.com/api/get-vehicle-details?type=options&onlymat=''&nomat=''&productId=${app._getCookie('productID')}&mcat=${app._getCookie('mcat')}&subModel=${app._getCookie('vehicle_submodel')}&baseVehicle=${app._getCookie('vehicle_base_vehicle')}`)
    //       .then((response) => {
    //         app.getOptionJson = response.data;
    //         app.isLoading = false;
    //         window.location.href = '/pages/recommendation-wizard';
    //         return response.data;
    //       })
    //       .catch((error) => {
    //         app.isLoading = false;
    //         throw error;
    //       });
    //   }
    // },

    _setVehicleCookie: function _setVehicleCookie() {
      var today = new Date();
      var expirationDate = new Date();
      expirationDate.setDate(today.getDate());
      var time = expirationDate.getTime();
      var expireTime = time + 1000 * 36000;
      expirationDate.setTime(expireTime);
      document.cookie = 'vehicle_details=' + app.selectedYear + ' ' + app.selectedMake + ' ' + app.selectedModel + ';expires=' + expirationDate.toGMTString() + ';path=/';
      document.cookie = 'vehicle_details_display=' + app.selectedYear + ' ' + app.selectedMake + ' ' + app.selectedModel + ' ' + app.selectedSubModel + ';expires=' + expirationDate.toGMTString() + ';path=/';
      document.cookie = 'vehicle_year=' + app.selectedYear + ';expires=' + expirationDate.toGMTString() + ';path=/';
      document.cookie = 'vehicle_make=' + app.selectedMake + ';expires=' + expirationDate.toGMTString() + ';path=/';
      document.cookie = 'vehicle_model=' + app.selectedModel + ';expires=' + expirationDate.toGMTString() + ';path=/';
      document.cookie = 'vehicle_submodel=' + app.selectedSubModel + ';expires=' + expirationDate.toGMTString() + ';path=/';
      document.cookie = 'vehicle_base_vehicle=' + app.selectedbaseVehicle + ';expires=' + expirationDate.toGMTString() + ';path=/';
    },
    _clearVehicleCookie: function _clearVehicleCookie() {
      document.cookie = 'vehicle_details=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = 'vehicle_details_display=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = 'vehicle_year=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = 'vehicle_make=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = 'vehicle_model=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = 'vehicle_submodel=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = 'vehicle_base_vehicle=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = 'mainMaterial=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = 'productID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = 'mcat=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      app.cookieSelectedVehicle = '';
      app.cookieSelectedVehicleDisplay = '';
    },
    _switchProductsURL: function _switchProductsURL() {
      // eslint-disable-next-line max-statements-per-line
      var customHandle = void 0;var meterialHandle = void 0;var mainProduct = void 0;var makeHandle = void 0;
      mainProduct = jQuery.inArray('main_material', app.product.tags);
      if (app.product.handle.indexOf('floor-mats') > -1) {
        customHandle = app._handleize(app._getCookie('vehicle_year')) + '-' + app._handleize(app._getCookie('vehicle_make')) + '-' + app._handleize(app._getCookie('vehicle_model'));
        makeHandle = customHandle + '-floor-mats';
      } else if (app.product.handle.indexOf('frost-shield') > -1) {
        customHandle = app._handleize(app._getCookie('vehicle_year')) + '-' + app._handleize(app._getCookie('vehicle_make')) + '-' + app._handleize(app._getCookie('vehicle_model'));
        makeHandle = customHandle + '-frost-shield';
      } else if (app.product.handle.indexOf('sunshield') > -1) {
        customHandle = app._handleize(app._getCookie('vehicle_year')) + '-' + app._handleize(app._getCookie('vehicle_make')) + '-' + app._handleize(app._getCookie('vehicle_model'));
        makeHandle = customHandle + '-custom-sunshield';
      } else {
        customHandle = app._handleize(app._getCookie('vehicle_year')) + '-' + app._handleize(app._getCookie('vehicle_make')) + '-' + app._handleize(app._getCookie('vehicle_model'));
        meterialHandle = app.product.handle.split('-cover-');
        makeHandle = customHandle + '-' + meterialHandle[0] + '-cover';
      }
      // eslint-disable-next-line eqeqeq
      if (mainProduct > -1) {
        $('[data-product-template]').css('opacity', '0');
        app.isOverlayVisible = true;
        app.isSpinnerVisible = true;
        var today = new Date();
        var expirationDate = new Date();
        expirationDate.setDate(today.getDate());
        var time = expirationDate.getTime();
        var expireTime = time + 1000 * 36000;
        expirationDate.setTime(expireTime);
        app.product.tags.forEach(function (tag) {
          if (tag.match('mcat')) {
            var data = tag.replace('mcat-', '');
            document.cookie = 'mcat=' + data + ';expires=' + expirationDate.toGMTString() + ';path=/';
          }
          if (tag.match('productID')) {
            var _data = tag.replace('productID_', '');
            document.cookie = 'productID=' + _data + ';expires=' + expirationDate.toGMTString() + ';path=/';
          }
          if (tag.match('main_material')) {
            var productObj1 = app.selectors.productSubObj;
            var productData1 = JSON.parse($(productObj1).html());
            document.cookie = 'mainMaterial=' + productData1.productHandle + ';expires=' + expirationDate.toGMTString() + ';path=/';
          }
        });
        axios.get('/products/' + makeHandle)
        // eslint-disable-next-line promise/always-return
        .then(function (response) {
          app.cookieSelectedVehicleURL = '/products/' + makeHandle;
          setTimeout(function () {
            window.location.href = app.cookieSelectedVehicleURL;
          }, 300);
        }).catch(function (error) {
          app.isOverlayVisible = false;
          app.isSpinnerVisible = false;
          app.isLoading = false;
          $('[data-product-template]').css('opacity', '1');
          $('[data-model-toggle]').show();
          $('[data-notify-me]').removeClass('d-none');
          $('[data-hide-section]').addClass('d-none');
          // eslint-disable-next-line eqeqeq
          if (app._getCookie('vehicle_year') != 'vehicle_year') {
            $('[data-model-toggle]').addClass('d-none');
          }
          throw error;
        });
      }
    },
    _optionChange: function _optionChange(event, typeProduct) {
      // eslint-disable-next-line eqeqeq
      if (typeProduct == 'universal-seat-design') {
        app.getUniversalCategory = [];
        app.selectedUniversalCategory = '';
        app.getUniversalResourse = [];
        app.selectedUniversalResourse = '';
        app.selectedMaterialNameUltimate = '';
        app.selectedUniversalDesign = $(event.currentTarget).val();
        app._getUniversalSeatCategory();
        // eslint-disable-next-line eqeqeq
      } else if (typeProduct == 'universal-seat-category') {
        app.getUniversalResourse = [];
        app.selectedUniversalResourse = '';
        app.selectedMaterialNameUltimate = '';
        app.selectedUniversalCategory = $(event.currentTarget).val();
        app._getUniversalSeatResources();
      } else {
        app.selectedRecID = $(event.currentTarget).val();
        $(event.currentTarget).closest('[data-seat-template]').attr('data-recID', app.selectedRecID);
        $('[data-vehicle-style]').text($(event.currentTarget).find('option:selected').text());
        if (app.getOptionJson.Material_Category_Img_Lists.Swatches.length > 0 && app.getOptionJson.Option_Generated.length > 0) {
          // eslint-disable-next-line eqeqeq
          if (app.selectedMaterialID != '' && app.selectedRecID != '') {
            app._getCartPrice(event);
          }
          // eslint-disable-next-line eqeqeq
        } else if (app.selectedRecID != '') {
          app._getCartPrice(event);
        }
      }
    },
    _subProductChange: function _subProductChange(event) {
      // let flag = false;
      // $('[data-seat-template] [data-color-group]').each(function() {
      //   console.log($(this).find('input:checked').val());
      //   // eslint-disable-next-line eqeqeq
      //   if ($(this).find('input:checked').val() == undefined) {
      //     flag = true;
      //   }
      // });
      // eslint-disable-next-line eqeqeq
      // if (flag == false) {
      $('[data-submit-form]').removeAttr('disabled');
      // }
    },
    _getShipDays: function _getShipDays(varianTitle, event) {
      // eslint-disable-next-line eqeqeq
      if (app.mainProduct != '' && app.mainProduct.tags.indexOf('productID_CVC') > -1) {
        if (varianTitle.indexOf('/') > -1) {
          varianTitle = $.trim(varianTitle.split('/')[0]);
        }
        app.itemIDCart = varianTitle + app.selectedMaterialID;
        axios.get('https://cpiapi.coverking.com/api/get-vehicle-details?type=ship-days&itemId=' + varianTitle + app.selectedMaterialID)
        // eslint-disable-next-line promise/always-return
        .then(function (response) {
          app.shipDays = response.data.Ship_Days.Business_Days;
        }).catch(function (error) {
          throw error;
        });
        // eslint-disable-next-line eqeqeq
      } else if (app.itemID != '' && varianTitle == 'universal') {
        app.itemIDCart = app.itemID;
        axios.get('https://cpiapi.coverking.com/api/get-vehicle-details?type=ship-days&itemId=' + app.itemID)
        // eslint-disable-next-line promise/always-return
        .then(function (response) {
          app.shipDays = response.data.Ship_Days.Business_Days;
          $(event.currentTarget).closest('[data-seat-template]').find('[data-sku-item]').addClass('d-none');
          $(event.currentTarget).closest('[data-seat-template]').find('[data-sku-item=' + app._getCookie('productID') + '][data-sku-select=' + app.selectedMaterialID + '] span').text(response.data.Ship_Days.Business_Days);
          $(event.currentTarget).closest('[data-seat-template]').find('[data-sku-item=' + app._getCookie('productID') + '][data-sku-select=' + app.selectedMaterialID + ']').removeClass('d-none').addClass('activeVar');
        }).catch(function (error) {
          throw error;
        });
      } else {
        app.itemIDCart = app._getCookie('productID') + app.selectedMaterialID;
        axios.get('https://cpiapi.coverking.com/api/get-vehicle-details?type=ship-days&itemId=' + app._getCookie('productID') + app.selectedMaterialID)
        // eslint-disable-next-line promise/always-return
        .then(function (response) {
          app.shipDays = response.data.Ship_Days.Business_Days;
        }).catch(function (error) {
          throw error;
        });
      }
    },
    _getCartPrice: function _getCartPrice(event) {
      // eslint-disable-next-line shopify/jquery-dollar-sign-reference
      var target = $(event.currentTarget);
      var dataText = $(target).closest('[data-seat-template]').find('[data-title]').text();
      axios.get('https://cpiapi.coverking.com/api/get-vehicle-details?type=price&itemNo=\'\'&mcat=' + app._getCookie('mcat') + '&productId=' + app._getCookie('productID') + '&recid=' + app.selectedRecID + '&materialId=' + app.selectedMaterialID + '&baseVehicle=' + app._getCookie('vehicle_base_vehicle')).then(function (response) {
        app.getCartPrice = response.data.Cart_Price;
        var varianSKU = '';
        var varianTitle = '';
        var variantPrice = '';
        // eslint-disable-next-line promise/always-return
        if (app.getCartPrice !== '') {
          // eslint-disable-next-line eqeqeq
          if (app.product.handle.indexOf('deck-cover') == -1 || app.product.handle.indexOf('dash-cover') == -1) {
            if (app.product.handle.indexOf('seat-cover') > -1 || app.product.handle.indexOf('floor-mats') > -1) {
              setTimeout(function () {
                var add = 0;
                $('[data-seat-template]').each(function (index) {
                  // eslint-disable-next-line eqeqeq
                  if ($(this).find('[data-name-swatch]').text() != '' && $(this).find('[data-more-about]').val() != '') {
                    // eslint-disable-next-line radix
                    add += parseInt($(this).closest('[data-seat-template]').find('[data-var-price]').attr('data-var-price'));
                    $('[data-price-change]').text('- ' + app._formatMoney(add));
                    $('[data-price] [data-price-change]').text('' + app._formatMoney(add));
                  }
                });
              }, 700);
            }
            var arrayOfVariants = [];
            app.mainProduct.variantsALL.forEach(function (variant) {
              // eslint-disable-next-line eqeqeq
              if (app.getCartPrice == app._formatMoney(variant.price).replace('$', '')) {
                if (app.product.handle.indexOf('seat-cover') > -1) {
                  if ($.trim(variant.option1) == $.trim(dataText)) {
                    arrayOfVariants.push(variant);
                  }
                } else {
                  arrayOfVariants.push(variant);
                }
              }
            });

            if (arrayOfVariants.length > 1) {
              arrayOfVariants.forEach(function (variant) {
                if (app.selectedMaterialID.charAt(0) == '2' && variant.title.indexOf('2-tone') > -1) {
                  app.mainAddToCartID = variant.id;
                  varianTitle = variant.title;
                  varianSKU = variant.sku;
                  variantPrice = variant.price;
                  return false;
                }
                if (app.selectedMaterialID.charAt(0) != '2' && variant.title.indexOf('2-tone') == -1) {
                  app.mainAddToCartID = variant.id;
                  varianTitle = variant.title;
                  varianSKU = variant.sku;
                  variantPrice = variant.price;
                  return false;
                }
                if (app.product.handle.indexOf('seat-cover') == -1 && $('[data-name-swatch]').text().indexOf('2-Tone') > -1 && variant.title.indexOf('2-tone') > -1) {
                  app.mainAddToCartID = variant.id;
                  varianTitle = variant.title;
                  varianSKU = variant.sku;
                  variantPrice = variant.price;
                  return false;
                }
                if (app.product.handle.indexOf('seat-cover') == -1 && $('[data-name-swatch]').text().indexOf('2-Tone') == -1 && variant.title.indexOf('2-tone') == -1) {
                  app.mainAddToCartID = variant.id;
                  varianTitle = variant.title;
                  varianSKU = variant.sku;
                  variantPrice = variant.price;
                  return false;
                }
              });
            } else {
              app.mainAddToCartID = arrayOfVariants[0].id;
              varianTitle = arrayOfVariants[0].title;
              varianSKU = arrayOfVariants[0].sku;
              variantPrice = arrayOfVariants[0].price;
            }
            console.log(app.getCartPrice, varianTitle, variantPrice);
            $(target).closest('[data-seat-template]').attr('data-seat-template', app.mainAddToCartID);
            $(target).closest('[data-seat-template]').find('[data-var-price]').attr('data-var-price', variantPrice).text(app._formatMoney(variantPrice));
            $('[data-add-to-cart-product]').removeAttr('disabled');
            $('[data-price]').html('<span data-price-change class="h5 actual-price"></span>');
            $('[data-hide-notify-me]').removeClass('d-none').addClass('d-flex');
            $('[data-notify-me-2]').addClass('d-none');
            setTimeout(function () {
              // eslint-disable-next-line eqeqeq
              if (app.product.handle.indexOf('seat-cover') == -1 && app.product.handle.indexOf('floor-mats') == -1) {
                if ($('.activeVar').length > 0) {
                  $('[data-add-to-cart-product]').html('Add to cart - <span data-price-change class="ml-1"></span>');
                  // eslint-disable-next-line radix
                  var add = parseInt($('.activeVar').closest('[data-seat-template]').find('[data-var-price]').attr('data-var-price'));
                  // eslint-disable-next-line radix
                  add += parseInt(variantPrice);
                  $('[data-price-change]').text('- ' + app._formatMoney(add));
                  $('[data-price] [data-price-change]').text('' + app._formatMoney(add));
                } else {
                  $('[data-add-to-cart-product]').html('Add to cart <span data-price-change class="ml-1"></span>');
                  $('[data-price-change]').text('- ' + app._formatMoney(variantPrice));
                  $('[data-price] [data-price-change]').text('' + app._formatMoney(variantPrice));
                }
              }
            }, 700);
          } else {
            app.mainAddToCartID = app.mainProduct.variantsALL[0].id;
          }
          // eslint-disable-next-line eqeqeq
          if (app.mainProduct != '' && app.mainProduct.tags.indexOf('productID_CVC') > -1) {
            app._getShipDays(varianTitle);
            // eslint-disable-next-line eqeqeq
          } else {
            setTimeout(function () {
              var shipIDPass = '' + app._getCookie('productID') + app.selectedMaterialID;
              if (app.product.handle.indexOf('floor-mats') > -1) {
                // eslint-disable-next-line eqeqeq
                if ($.trim(dataText) == 'Front') {
                  shipIDPass = app._getCookie('productID') + 'A' + app.selectedMaterialID;
                  // eslint-disable-next-line eqeqeq
                } else if ($.trim(dataText) == 'Front Center') {
                  shipIDPass = app._getCookie('productID') + 'B' + app.selectedMaterialID;
                } else {
                  shipIDPass = app._getCookie('productID') + 'C' + app.selectedMaterialID;
                }
              }
              // eslint-disable-next-line eqeqeq
              if (app.itemID != '' && varianTitle == 'universal') {
                app.itemIDCart = app.itemID;
              } else {
                app.itemIDCart = shipIDPass;
              }
              // eslint-disable-next-line promise/no-nesting
              axios.get('https://cpiapi.coverking.com/api/get-vehicle-details?type=ship-days&itemId=' + shipIDPass)
              // eslint-disable-next-line promise/always-return
              .then(function (response) {
                app.shipDays = response.data.Ship_Days.Business_Days;
                $(target).closest('[data-seat-template]').find('[data-sku-item]').addClass('d-none');
                $(target).closest('[data-seat-template]').find('[data-sku-item=' + app._getCookie('productID') + '][data-sku-select=' + app.selectedMaterialID + '] span').text(response.data.Ship_Days.Business_Days);
                $(target).closest('[data-seat-template]').find('[data-sku-item=' + app._getCookie('productID') + '][data-sku-select=' + app.selectedMaterialID + ']').removeClass('d-none').addClass('activeVar');
              }).catch(function (error) {
                throw error;
              });
            }, 100);
          }
          return response.data.Cart_Price;
        } else {
          $('[data-add-to-cart-product]').html('Unavailable');
          $('[data-hide-notify-me]').addClass('d-none').removeClass('d-flex');
          $('[data-notify-me-2]').removeClass('d-none');
        }
      }).catch(function (error) {
        if ($('[data-closest]').length && $('[data-closest] [data-color-swatch-group]').length == 0 || $('[data-seat-template]').length && $('[data-seat-template] [data-color-swatch-group]').length == 0) {
          $('[data-hide-notify-me]').addClass('d-none').removeClass('d-flex');
          $('[data-notify-me-2]').removeClass('d-none');
        }
        throw error;
      });
    },
    _freeFabricSwatch: function _freeFabricSwatch(event) {
      var $target = $(event.currentTarget);
      var productId = $target.find('option:checked').attr('value');
      axios.get('https://cpiapi.coverking.com/api/get-materials?productId=' + productId).then(function (response) {
        app.allMaterials = response.data.materials;
        $target.closest('[data-swatch-values]').find('[data-opacity-add]').removeAttr('style');
        return response.data;
      }).catch(function (error) {
        throw error;
      });
    },
    _freeFabricSwatchMaterial: function _freeFabricSwatchMaterial(event, image, title, code, number) {
      $(event.currentTarget).closest('.dropdown').find('[data-selected] [data-img]').attr('src', image);
      $(event.currentTarget).closest('.dropdown').find('[data-selected] [data-title]').text(title);
      $(event.currentTarget).closest('.dropdown').find('[data-selected] [data-ID]').text(code);
      $(event.currentTarget).closest('.dropdown').find('[data-selected-title]').addClass('d-none');
      $(event.currentTarget).closest('.dropdown').find('[data-selected]').removeClass('invisible');
      // eslint-disable-next-line eqeqeq
      if (number == '1') {
        $('[data-more]').removeClass('d-none');
      }
      $('[data-opacity-add-form]').removeAttr('style');
    },
    _showMore: function _showMore(event) {
      if ($('[data-show-more]').hasClass('d-none')) {
        $('[data-show-more]').removeClass('d-none');
      } else if ($('[data-show-more-1]').hasClass('d-none')) {
        $('[data-show-more-1]').removeClass('d-none');
      } else if ($('[data-show-more-2]').hasClass('d-none')) {
        $('[data-show-more-2]').removeClass('d-none');
      } else if ($('[data-show-more-3]').hasClass('d-none')) {
        $('[data-show-more-3]').removeClass('d-none');
      }
      // eslint-disable-next-line eqeqeq
      if ($('[data-show-more]').hasClass('d-none') == false && $('[data-show-more-1]').hasClass('d-none') == false && $('[data-show-more-2]').hasClass('d-none') == false && $('[data-show-more-3]').hasClass('d-none') == false) {
        $(event.currentTarget).addClass('d-none');
      }
    },
    _showLess: function _showLess(event, number) {
      $('[data-more]').removeClass('d-none');
      // eslint-disable-next-line eqeqeq
      if (number == '0') {
        $('[data-show-more]').addClass('d-none');
        $('[data-show-more]').find('[data-selected] [data-img]').attr('src', '');
        $('[data-show-more]').find('[data-selected] [data-ID]').text('');
        $('[data-show-more]').find('[data-selected] [data-title]').text('');
        $('[data-show-more]').find('[data-selected-title]').removeClass('d-none');
        $('[data-show-more]').find('[data-selected]').addClass('invisible');
        $('[data-show-more]').find('[name="collections"] option:first').attr('selected', 'selected');
        $('[data-show-more]').find('[data-ul-li]').html('');
        $('[data-show-more]').find('[data-opacity-add]').css({
          opacity: '0.5',
          'pointer-events': 'none'
        });
        // eslint-disable-next-line eqeqeq
      } else if (number == '1') {
        $('[data-show-more-1]').addClass('d-none');
        $('[data-show-more-1]').find('[data-selected] [data-img]').attr('src', '');
        $('[data-show-more-1]').find('[data-selected] [data-ID]').text('');
        $('[data-show-more-1]').find('[data-selected] [data-title]').text('');
        $('[data-show-more-1]').find('[data-selected-title]').removeClass('d-none');
        $('[data-show-more-1]').find('[data-selected]').addClass('invisible');
        $('[data-show-more-1]').find('[name="collections"] option:first').attr('selected', 'selected');
        $('[data-show-more-1]').find('[data-ul-li]').html('');
        $('[data-show-more-1]').find('[data-opacity-add]').css({
          opacity: '0.5',
          'pointer-events': 'none'
        });
        // eslint-disable-next-line eqeqeq
      } else if (number == '2') {
        $('[data-show-more-2]').addClass('d-none');
        $('[data-show-more-2]').find('[data-selected] [data-img]').attr('src', '');
        $('[data-show-more-2]').find('[data-selected] [data-ID]').text('');
        $('[data-show-more-2]').find('[data-selected] [data-title]').text('');
        $('[data-show-more-2]').find('[data-selected-title]').removeClass('d-none');
        $('[data-show-more-2]').find('[data-selected]').addClass('invisible');
        $('[data-show-more-2]').find('[name="collections"] option:first').attr('selected', 'selected');
        $('[data-show-more-2]').find('[data-ul-li]').html('');
        $('[data-show-more-2]').find('[data-opacity-add]').css({
          opacity: '0.5',
          'pointer-events': 'none'
        });
        // eslint-disable-next-line eqeqeq
      } else if (number == '3') {
        $('[data-show-more-3]').addClass('d-none');
        $('[data-show-more-3]').find('[data-selected] [data-img]').attr('src', '');
        $('[data-show-more-3]').find('[data-selected] [data-ID]').text('');
        $('[data-show-more-3]').find('[data-selected] [data-title]').text('');
        $('[data-show-more-3]').find('[data-selected-title]').removeClass('d-none');
        $('[data-show-more-3]').find('[data-selected]').addClass('invisible');
        $('[data-show-more-3]').find('[name="collections"] option:first').attr('selected', 'selected');
        $('[data-show-more-3]').find('[data-ul-li]').html('');
        $('[data-show-more-3]').find('[data-opacity-add]').css({
          opacity: '0.5',
          'pointer-events': 'none'
        });
      }
    },
    _submitLoginHelperForm: function _submitLoginHelperForm() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var formEl, formData, customerEmail, customerPassword, loginType, config, headers;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                formEl = $('#customer_login')[0];
                formData = new FormData(formEl);
                customerEmail = formData.get('customer[email]');
                customerPassword = formData.get('customer[password]');
                loginType = app.loginHelper.settings.type;


                app.isLoading = true;

                config = {
                  url: '/customers/search.json?query=email:' + customerEmail,
                  method: 'GET',
                  data: []
                };
                headers = { Accept: 'application/json' };
                _context.prev = 8;
                _context.next = 11;
                return axios.post('/tools/ha-api/shopify/common', config, { headers: headers }).then(function (response) {
                  var message = '';
                  // eslint-disable-next-line eqeqeq
                  if (response.data.customers.length == 1) {
                    // eslint-disable-next-line eqeqeq
                    if (response.data.customers[0].state == 'disabled') {
                      var msg = unescape(app.loginHelper.settings.account_disable).split('.');
                      // msg.forEach((x) => {
                      message += 'Please check your email to reset password. <br/>';
                      // });
                      var configInvite = {
                        url: '/customers/' + response.data.customers[0].id + '/send_invite.json',
                        method: 'POST',
                        data: {
                          customer_invite: {
                            to: '' + response.data.customers[0].email,
                            from: 'admin@customcovers.com',
                            bcc: [],
                            subject: 'Customer account activation',
                            custom_message: 'Hi ' + response.data.customers[0].first_name + ', you\'ve created a new customer account at Coverking. All you have to do is activate it.'
                          }
                        }
                      };
                      // eslint-disable-next-line promise/catch-or-return
                      // eslint-disable-next-line promise/no-nesting
                      axios.post('/tools/ha-api/shopify/common', configInvite, { headers: headers }).then(function (responseI) {
                        console.log(responseI);
                      });
                      // eslint-disable-next-line eqeqeq
                    } else if (response.data.customers[0].state == 'invited') {
                      var _msg = unescape(app.loginHelper.settings.account_invited).split('.');
                      _msg.forEach(function (x) {
                        message += x + '.<br/>';
                      });
                      // eslint-disable-next-line eqeqeq
                    } else if (response.data.customers[0].state == 'enabled') {
                      var _msg2 = unescape(app.loginHelper.settings.account_enable).split('.');
                      _msg2.forEach(function (x) {
                        message += x + '.<br/>';
                      });
                      // eslint-disable-next-line eqeqeq
                    } else if (response.data.customers[0].state == 'declined') {
                      var _msg3 = unescape(app.loginHelper.settings.account_declined).split('.');
                      _msg3.forEach(function (x) {
                        message += x + '.<br/>';
                      });
                    }
                    app.loginHelper.status = response.data.customers[0].state;
                    app.loginHelper.message = message;
                  } else {
                    var _msg4 = unescape(app.loginHelper.settings.account_not_found).split('.');
                    _msg4.forEach(function (x) {
                      message += x + '.<br/>';
                    });
                    app.loginHelper.status = 'other';
                    app.loginHelper.message = message;
                  }
                  app.isLoading = false;
                  // eslint-disable-next-line promise/always-return
                  if (loginType === 'default') {
                    if (customerPassword) {
                      formEl.submit();
                    } else {
                      $('#customerPassword').addClass('is-invalid');
                    }
                  }
                });

              case 11:
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](8);

                app.isLoading = false;

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[8, 13]]);
      }))();
    },
    _autoComepleteByGoogle: function _autoComepleteByGoogle() {
      // eslint-disable-next-line prefer-const
      autocomplete = new google.maps.places.Autocomplete(
      /** @type {!HTMLInputElement} */document.getElementById('route'), { types: ['geocode'] });

      // When the user selects an address from the dropdown, populate the address
      // fields in the form.
      autocomplete.addListener('place_changed', fillInAddress);

      // [START region_fillform]
      function fillInAddress() {
        // Get the place details from the autocomplete object.
        var place = autocomplete.getPlace();
        // eslint-disable-next-line guard-for-in
        for (var component in componentForm) {
          document.getElementById(component).value = '';
        }

        // Get each component of the address from the place details
        // and fill the corresponding field on the form.
        // eslint-disable-next-line no-var
        for (var i = 0; i < place.address_components.length; i++) {
          // search country
          var addressType = place.address_components[i].types[0];
          // eslint-disable-next-line eqeqeq
          if (addressType == 'country') {
            var val = place.address_components[i].long_name;

            $('#p_country').val('United States');
            var invalid_country = true;
            // eslint-disable-next-line eqeqeq
            if (val == 'United States') {
              $('#p_state').show();
              $('#p_state2').hide();
              invalid_country = false;
            }
            // eslint-disable-next-line eqeqeq
            if (val == 'Canada') {
              invalid_country = true;
            }

            // eslint-disable-next-line eqeqeq
            if (invalid_country == true) {
              alert('Only Available for United States');
              // eslint-disable-next-line guard-for-in
              for (var _component in componentForm) {
                document.getElementById(_component).value = '';
              }
            }
          }
        }
        var Street_Address = '';
        for (var _i = 0; _i < place.address_components.length; _i++) {
          var _addressType = place.address_components[_i].types[0];

          var SelectedCountry = $('#p_country').val();
          // eslint-disable-next-line eqeqeq
          if (_addressType == 'administrative_area_level_1' && SelectedCountry == 'United States') {
            var _val = place.address_components[_i].long_name;
            $('#p_state').val(_val);
          }

          // eslint-disable-next-line eqeqeq
          if (_addressType == 'administrative_area_level_1' & SelectedCountry == 'Canada') {
            // eslint-disable-next-line no-var
            var _val2 = place.address_components[_i].long_name;
            // eslint-disable-next-line block-scoped-var
            $('#p_state2').val(_val2);
          }
          if (componentForm[_addressType]) {
            var _val3 = place.address_components[_i][componentForm[_addressType]];
            document.getElementById(_addressType).value = _val3;
            // eslint-disable-next-line eqeqeq
            if (_addressType == 'street_number') {
              document.getElementById(_addressType).value = '';
              Street_Address = _val3;
            }
            // eslint-disable-next-line eqeqeq
            if (_addressType == 'route') {
              document.getElementById(_addressType).value = Street_Address + ' ' + _val3;
            }
            // document.getElementById(addressType).disabled = true;
          }
        }
      }
      // [END region_fillform]
      app._geolocate();
    },
    _geolocate: function _geolocate() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          var geolocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          var circle = new google.maps.Circle({
            center: geolocation,
            radius: position.coords.accuracy
          });
          autocomplete.setBounds(circle.getBounds());
        });
      }
      // [END region_geolocation]
    },
    _submitFreeFabric: function _submitFreeFabric(event, formID) {
      // eslint-disable-next-line eqeqeq
      if ($(event.currentTarget).closest('form').find('[data-name]').val() == '' || $(event.currentTarget).closest('form').find('[data-address-1]').val() == '' || $(event.currentTarget).closest('form').find('[data-city]').val() == '' ||
      // eslint-disable-next-line eqeqeq
      $(event.currentTarget).closest('form').find('[data-state]').val() == '' || $(event.currentTarget).closest('form').find('[data-zip]').val() == '' || $(event.currentTarget).closest('form').find('[data-phone]').val() == '' ||
      // eslint-disable-next-line eqeqeq
      $(event.currentTarget).closest('form').find('[data-email]').val() == '') {
        app._snotifyMsg('Error', 'Fill all the reuqired fields.', 'Error');
        return false;
      }

      $(event.currentTarget).addClass('btn-disabled');
      app.isLoading = true;
      app.loadingEvent = 'contactSubmit';

      var form = new FormData();

      var count = 0;
      $('[data-swatch-values]').each(function (index) {
        // eslint-disable-next-line eqeqeq
        if ($(this).find('[data-selected] span').text() != '') {
          count += 1;
          form.append('formResponse[Product-' + count + ']', $(this).find('[data-material] option:selected').text());
          form.append('formResponse[Material-Name-' + count + ']', $(this).find('[data-selected] [data-title]').text());
          form.append('formResponse[Material-ID-' + count + ']', $(this).find('[data-selected] [data-ID]').text());
        }
      });
      form.append('formResponse[Name]', $(event.currentTarget).closest('form').find('[data-name]').val());
      form.append('formResponse[Address 1]', $(event.currentTarget).closest('form').find('[data-address-1]').val());
      // eslint-disable-next-line eqeqeq
      if ($(event.currentTarget).closest('form').find('[data-address-2]') != '') {
        form.append('formResponse[Address 2]', $(event.currentTarget).closest('form').find('[data-address-2]').val());
      }
      form.append('formResponse[City]', $(event.currentTarget).closest('form').find('[data-city]').val());
      form.append('formResponse[State]', $(event.currentTarget).closest('form').find('[data-state]').val());
      form.append('formResponse[Zip]', $(event.currentTarget).closest('form').find('[data-zip]').val());
      form.append('formResponse[Country]', $(event.currentTarget).closest('form').find('[data-country]').val());
      form.append('formResponse[Phone]', $(event.currentTarget).closest('form').find('[data-phone]').val());
      form.append('formResponse[Email]', $(event.currentTarget).closest('form').find('[data-email]').val());

      var settings = {
        async: true,
        crossDomain: true,
        url: 'https://formbuilder.hulkapps.com/forms/' + formID,
        method: 'POST',
        headers: {
          'X-Form-Access-Token': 'b7504fef28d3a3bf',
          Accept: 'application/json',
          'cache-control': 'no-cache',
          'Access-Control-Allow-Origin': '*'
        },
        processData: false,
        contentType: false,
        mimeType: 'multipart/form-data',
        data: form
      };
      $.ajax(settings).done(function (response) {
        $('[data-free-swatches]').removeClass('btn-disabled');
        app.isLoading = false;
        app.loadingEvent = null;
        // eslint-disable-next-line eqeqeq
        if (JSON.parse(response).error != undefined && JSON.parse(response).error) {
          app._snotifyMsg('Error', JSON.parse(response).error, 'Error');
        } else {
          $(event.currentTarget).closest('form').find('input').val('');
          app._snotifyMsg('Success', 'Your message has been submitted successfully.', 'Success');
        }
      });
    },
    _getOrdersByLastName: function _getOrdersByLastName() {
      // eslint-disable-next-line eqeqeq
      if (app.lastName != '' && app.zipNumber != '') {
        app.isLoading = true;
        app.loadingEvent = 'orderStatus';
        axios.get('https://cpiapi.coverking.com/api/get-vehicle-details?type=orders-by-last-name&lastName=' + app.lastName + '&zip=' + app.zipNumber).then(function (response) {
          app.orderLastZipResponse = response.data.Orders;
          if (response.data.Orders.length == 0) {
            app._snotifyMsg('Error', 'No order found!.', 'Error');
          }
          app.orderSerialOrderResponse = [];
          app.isLoading = false;
          app.loadingEvent = null;
          return response.data;
        }).catch(function (error) {
          app.isLoading = false;
          app.loadingEvent = null;
          app._snotifyMsg('Error', 'Something might be wrong.', 'Error');
          throw error;
        });
      } else {
        app._snotifyMsg('Error', 'Fill the fields.', 'Error');
      }
    },
    _getOrdersByOrderNoSerialNo: function _getOrdersByOrderNoSerialNo(order, serial) {
      // eslint-disable-next-line eqeqeq
      if (app.orderNo != '' && app.serialNo != '') {
        app.isLoading = true;
        app.loadingEvent = 'orderStatus';
        axios.get('https://cpiapi.coverking.com/api/get-vehicle-details?type=orders-by-orderno-and-serialno&orderNo=' + app.orderNo + '&serialNo=' + app.serialNo).then(function (response) {
          app.orderSerialOrderResponse = response.data.Order;
          app.orderLastZipResponse = [];
          app.isLoading = false;
          app.loadingEvent = null;
          if (response.data.Order == null) {
            app._snotifyMsg('Error', 'No Order found.', 'Error');
          }
          return response.data;
        }).catch(function (error) {
          app.isLoading = false;
          app.loadingEvent = null;
          app._snotifyMsg('Error', 'Something might be wrong.', 'Error');
          throw error;
        });
      } else {
        app._snotifyMsg('Error', 'Fill the fields.', 'Error');
      }
    },
    _getUniversalInventory: function _getUniversalInventory(itemNo) {
      axios.get('https://cpiapi.coverking.com/api/get-vehicle-details?type=universal-inventory&itemNo=' + itemNo).then(function (response) {
        return response.data;
      }).catch(function (error) {
        app._snotifyMsg('Error', 'Something might be wrong.', 'Error');
        throw error;
      });
    },
    _zendeskData: function _zendeskData(event) {
      // const dataInput = $(event.currentTarget).closest('[data-target-form]').find('input').val();
      // eslint-disable-next-line eqeqeq
      if (app.searchText != '') {
        app.isLoading = true;
        axios.get('https://cpiapi.coverking.com/api/get-contact-support?query=' + app.searchText).then(function (response) {
          app.isLoading = false;
          app.searchTemplate = response.data;
          return response.data;
        }).catch(function (error) {
          app.isLoading = false;
          app._snotifyMsg('Error', 'Something might be wrong.', 'Error');
          throw error;
        });
      } else {
        app._snotifyMsg('Error', 'No data found!', 'Error');
      }
    },
    _installationNextSteps: function _installationNextSteps(event, next, current, make, src) {
      $('[data-step=' + current + ']').addClass('d-none');
      // eslint-disable-next-line eqeqeq
      if (next == '2') {
        app.selectedModelVideo = $(event.currentTarget).find('.card-title').text();
        var handle = app._handleize(app.selectedModelVideo);
        app.selectedVideoMake = make;
        app.selectedVideoMakeSRC = src;
        app._allVideosByMake(event);
      } else {
        app.selectedTypeVideo = $(event.currentTarget).find('.card-title').text();
        var _handle = app._handleize(app.selectedTypeVideo);
        app.selectedVideoModel = make;
        app._allVideosByModel(event);
      }
    },
    _installationBackSteps: function _installationBackSteps(event, previous) {
      $('[data-step]').addClass('d-none');
      $('[data-step=' + previous + ']').removeClass('d-none');
      // eslint-disable-next-line eqeqeq
      if (previous == '2') {
        app.selectedTypeVideo = '';
        app.allInstallationVideosModel = [];
        // eslint-disable-next-line eqeqeq
      } else if (previous == '1') {
        app.selectedTypeVideo = '';
        app.selectedModelVideo = '';
        app.selectedVideoMake = '';
        app.selectedVideoMakeSRC = '';
      }
    },
    _openVideo: function _openVideo(event, name, url) {
      $('#videoModal').modal('show');
      $('[data-video-name]').text(name);
      if (url.indexOf('watch') > -1) {
        url = url.replace('watch?v=', 'embed/');
      }
      if (url.indexOf('&') > -1) {
        url = url.split('&')[0];
      }
      app.selectedURLVideo = url;
    },
    _allVideos: function _allVideos() {
      app.isLoading = true;
      axios.get('https://cpiapi.coverking.com/api/get-vehicle-details?type=video-makes').then(function (response) {
        app.isLoading = false;
        var videos = [];
        $.each(response.data.Video_Makes, function (key, video) {
          var downCase = video.toLowerCase();
          var data = {};
          data.down = downCase;
          data.src = '//cdn.shopify.com/s/files/1/0562/3001/9234/files/' + app._handleize(downCase) + '_150x.png';
          data.title = video;
          videos.push(data);
        });
        app.allInstallationVideos = videos;
        return response.data;
      }).catch(function (error) {
        app.isLoading = false;
        app._snotifyMsg('Error', 'Something might be wrong.', 'Error');
        throw error;
      });
    },
    _allVideosByMake: function _allVideosByMake(event) {
      app.isLoading = true;
      axios.get('https://cpiapi.coverking.com/api/get-vehicle-details?type=video-models&make=' + app.selectedVideoMake).then(function (response) {
        app.isLoading = false;
        app.allInstallationVideosMake = response.data.Video_Models;
        setTimeout(function () {
          $('[data-step=2]').removeClass('d-none');
        }, 100);
        return response.data;
      }).catch(function (error) {
        app.isLoading = false;
        app._snotifyMsg('Error', 'Something might be wrong.', 'Error');
        throw error;
      });
    },
    _allVideosByModel: function _allVideosByModel(event) {
      app.isLoading = true;
      axios.get('https://cpiapi.coverking.com/api/get-vehicle-details?type=video-by-make&make=' + app.selectedVideoMake + '&model=' + app.selectedVideoModel).then(function (response) {
        app.isLoading = false;
        app.allInstallationVideosModel = response.data.Video_By_Makes;
        setTimeout(function () {
          $('[data-step=3]').removeClass('d-none');
        }, 100);
        return response.data;
      }).catch(function (error) {
        app.isLoading = false;
        app._snotifyMsg('Error', 'Something might be wrong.', 'Error');
        throw error;
      });
    },
    _submitNotification: function _submitNotification(event) {
      app.isLoading = true;
      var email = $(event.currentTarget).closest('#searchForm_1').find('input').val();
      axios.post('https://www.coverking.com/vehicle/ajax/saveNotification?email=' + email + '&product_id=' + app.product.id + '&vehicle_id=' + app._getCookie('vehicle_base_vehicle'))
      // eslint-disable-next-line promise/always-return
      .then(function (response) {
        app.isLoading = false;
        // eslint-disable-next-line promise/always-return
        if (response.data.success) {
          $('#email-responce').html('<h6 class="text-success">' + response.data.message + '</h6>').removeClass('d-none');
          $('[data-hide-text]').hide();
        } else {
          $('#email-responce').html('<h6 class="text-danger">' + response.data.message + '</h6>').removeClass('d-none');
          $('[data-hide-text]').hide();
        }
      }).catch(function (error) {
        app.isLoading = false;
        app._snotifyMsg('Error', 'Something might be wrong.', 'Error');
        throw error;
      });
    },
    _snotifyMsg: function _snotifyMsg(title, msg, type) {
      if (type === 'Success') {
        app.$snotify.success(msg, title, {
          timeout: 3000,
          showProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          buttons: [{
            text: 'Close',
            bold: true,
            closeOnClick: true
          }]
        });
      } else if (type === 'Error') {
        app.$snotify.error(msg, title, {
          timeout: 3000,
          showProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          buttons: [{
            text: 'Close',
            bold: true,
            closeOnClick: true
          }]
        });
      }
    }
  }
};

export default customMethods;